/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

/**
 * This is a select that goes well with react hook form Controller
 */

import React from 'react';
import Select from '../components/select';

type SelectProps = React.ComponentProps<typeof Select>;

export default function ControlledSelect({
  onChange,
  options,
  value,
  placeholder,
  ...rest
}: SelectProps) {
  return (
    <Select
      onChange={(value, meta) => onChange?.(value, meta)}
      options={options}
      value={value}
      placeholder={placeholder}
      {...rest}
    />
  );
}
